export default __webpack_public_path__ + "static/media/check-circle.09b3ab9c.svg";